import { z } from 'zod';
export const VehicleSchema = z.object({
    id: z.string(),
    userId: z.string(),
    plate: z.string(),
    brand: z.string().optional(),
    model: z.string().optional(),
    color: z.string().optional(),
    country: z.string().default('TN'),
    createdAt: z.date(),
});
export const CreateVehicleSchema = z.object({
    plate: z.string().regex(/^(\d{1,3} TU [1-9]\d{0,3}|RS [1-9]\d{0,5}|.{2,20})$/, 'Plaque d\'immatriculation invalide (formats: 151 TU 9339, RS 226561, ou plaque étrangère)'),
    brand: z.string().min(1, 'La marque est requise'),
    model: z.string().min(1, 'Le modèle est requis'),
    color: z.string().min(1, 'La couleur est requise'),
    country: z.string().default('TN'),
});
